<script lang="ts" setup>
import {
  backdropOpacity,
  form_product_step_one,
  inputValue,
  isMaskDrawerClosed,
  previewUrl,
} from '@/refs/product.refs';
import buttonProductPrevSim from './buttonProductPrevSim.vue';
import { formatPrice } from '@/utils/formatPrice';
import { form } from '@/refs/login.form.refs';

const emit = defineEmits(['handleToogleDrawer']);
const HandleToogleDrawer = () => {
  inputValue.value = null;
  isMaskDrawerClosed.value = true;
  backdropOpacity.value = 0.2;
  emit('handleToogleDrawer');
};
</script>
<template>
  <article
    @click.prevent="HandleToogleDrawer"
    class="border-selection relative box-border flex w-full flex-row items-center justify-between gap-[16px] rounded-2xl border border-solid p-1"
  >
    <div
      class="flex w-full flex-1 flex-col items-stretch gap-[4px] !self-center !p-0"
    >
      <p
        class="text-12px font-tt-semiBold-Normal text-grand-text leading-normal"
      >
        {{
          form_product_step_one.designation
            ? form_product_step_one.designation
            : 'Ajouter un titre'
        }}
      </p>

      <p
        class="text-12px font-tt-medium-Normal text-primary-softgray leading-normal"
      >
        {{
          form_product_step_one?.price
            ? formatPrice(Number(form_product_step_one?.price))
            : 'Ajouter un prix'
        }}
      </p>
      <p
        class="text-12px font-tt-normal-Normal text-secondary-text line-clamp-2 flex-1 leading-[14px]"
      >
        {{
          form_product_step_one?.description
            ? form_product_step_one?.description
            : 'Ajouter une description'
        }}
      </p>
    </div>

    <div
      class="bg-primary-softgray relative isolate flex flex-row items-center justify-center rounded-tr-[10px] rounded-br-[10px] px-2"
    >
      <buttonProductPrevSim />

      <div class="productCatPanier aspect-square w-20">
        <img
          v-if="previewUrl !== null"
          class="h-full w-full object-contain"
          :src="previewUrl === null ? '' : previewUrl"
          height="80"
          width="80"
          loading="lazy"
        />

        <p v-else class="text-12px font-tt-normal-Normal text-secondary-text">
          Ajouter un image
        </p>
      </div>
    </div>
  </article>
  <div class="bg-soft-gray my-[16px] h-px w-full" />
</template>

<style scoped>
.productCatPanier {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;

  border-radius: 10px 0px 0px 10px;
  padding: 5px;
}
.productCatPanier img {
  border-radius: 10px 0px 0px 10px;
  object-fit: contain;
}
</style>
